import React, { useCallback, useEffect } from 'react';
import ReactDOM from 'react-dom';
import cn from 'classnames';

import styles from './Modal.module.css';

const Modal = ({
  isShowing,
  hide,
  children,
  title,
  hideCloseButton = false,
  contentClassName = ''
}) => {
  useEffect(() => {
    const handleKeyDown = e => {
      if (e.key === 'Escape') {
        hide();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [hide]);

  const handleOverlayClick = useCallback(
    e => {
      if (e.target.closest('[data-modal]')) return;
      hide();
    },
    [hide]
  );

  return isShowing
    ? ReactDOM.createPortal(
        <>
          <div
            className={`${styles.modalOverlay} bg-black bg-opacity-80 fixed w-screen h-screen inset-0`}
            style={{ zIndex: 60 }}
          />
          <div
            className={`${styles.modal} w-full h-full fixed inset-0 outline-none`}
            style={{ zIndex: 60 }}
            aria-modal
            aria-hidden
            tabIndex={-1}
            role="dialog"
            onClick={handleOverlayClick}
          >
            <div className="relative z-40 flex items-center justify-center h-full">
              <div
                className={`${styles.modalContent} ${contentClassName} bg-white text-center rounded-lg shadow-xl relative flex flex-col`}
                data-modal
              >
                <div className={cn({ 'py-5 px-7 border-b border-neutral-200': title })}>
                  {title && (
                    <h3 className="text-base font-medium text-black uppercase tracking-2">
                      {title}
                    </h3>
                  )}
                  <button
                    className={cn(
                      'bg-neutral-300 w-8 h-8 rounded-full absolute flex items-center justify-center',
                      [{ hidden: hideCloseButton }]
                    )}
                    type="button"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={hide}
                    style={{ top: -16, right: -16 }}
                  >
                    <span aria-hidden="true">
                      <svg viewBox="0 0 64 64" className="w-5 h-5">
                        <path
                          d="M47.414 47.435a2.001 2.001 0 0 1-2.83 0l-12.6-12.6-12.589 12.59a2.002 2.002 0 0 1-2.83-2.831l12.588-12.589L16.567 19.42a2.001 2.001 0 0 1 2.83-2.83l12.587 12.586L44.58 16.577a2.001 2.001 0 1 1 2.83 2.83L34.815 32.006l12.6 12.6a2.001 2.001 0 0 1 0 2.83z"
                          fillRule="evenodd"
                        />
                      </svg>
                    </span>
                  </button>
                </div>
                <div className="p-5 overflow-x-hidden overflow-y-auto">{children}</div>
              </div>
            </div>
          </div>
        </>,
        document.body
      )
    : null;
};

export default Modal;
